<template>
  <div class="home-container">
    <!-- 地址信息栏 -->
    <div class="address-bar" v-if="!isYouke">
      <div class="address-info">
        <div class="address-icon">
          <van-icon name="wap-home-o" size="16" />
        </div>
        <div class="address-text">{{ currentHouseName }}</div>
      </div>
      <div class="switch-house" @click="showPicker = true">切换房屋</div>
    </div>

    <!-- 房屋选择弹窗 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :default-index="chooseindex"
      />
    </van-popup>

    <!-- 宣传横幅 -->
    <div class="banner">
      <div class="banner-bg"></div>
      <div class="banner-content">
        <div class="banner-title">智慧物业</div>
        <div class="banner-subtitle">助力小区居民美好生活</div>
        <div class="banner-dept">宿迁市住房和城乡建设局</div>
      </div>
    </div>

    <!-- 通知公告 -->
    <div class="notice-bar" @click="changeview('/common/detail/sqkb', (sqkbList[0] && sqkbList[0].id))">
      <van-icon name="volume-o" class="notice-icon" />
      <div class="notice-text">
        <van-notice-bar
          scrollable
          background="transparent"
          color="#666"
          :text="(sqkbList[0] && sqkbList[0].title) || ''"
        />
      </div>
    </div>

    <!-- 功能网格 -->
    <div class="feature-grid">
      <div
        class="feature-item"
        v-for="(value, index) in sylist"
        :key="index"
        v-show="!(value.name == '维修资金' && !showweixiu)"
        @click="changeview(value.to)"
      >
        <div class="feature-icon">
          <img :src="value.icon" alt="" />
        </div>
        <div class="feature-text">{{ value.name }}</div>
      </div>
    </div>

    <!-- 小区快报 -->
    <div class="yy"></div>
    <div class="xx">
      <div class="xxtitle">
        <van-tabs color="#568ef6" v-model="active">
          <van-tab title="小区快报"></van-tab>
        </van-tabs>

        <div class="gd" @click="gokb">
          <span>更多</span>
          <img src="../assets/gd.png" alt="" />
        </div>
      </div>
      <div class="tzcontent" v-show="active == 0">
        <div v-for="(item, index) in sqkbList" :key="index" style="width: 95%">
          <div class="xxitem">
            <div
              :class="{ isbold: !item.isRead }"
              class="tztitle"
              @click="changeview('/common/detail/sqkb', item.id)"
            >
              <div v-show="!item.isRead" class="new">新</div>
              {{ item.title | handleText2 }}
            </div>
            <div class="tzdate">{{ item.publishDate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部占位 -->
    <div style="height: 70px"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { Picker, Popup, NoticeBar, Icon, Tab, Tabs } from "vant";
import { Dialog } from "vant";
import { mapState, mapMutations } from "vuex";

Vue.use(Picker);
Vue.use(Popup);
Vue.use(NoticeBar);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);

export default {
  inject: ["reload"],
  data() {
    return {
      showPicker: false,
      showNewsSection: true,
      openId: '',
      pwd: process.env.VUE_APP_DEFAULT_PASSWORD,
      type: 'zhwygzh',
      active: 0,
      real: {
        weather: {},
        wind: { direct: '' }
      },
      whellList: [],
      sqkbList: [{ title: "" }],
      xxggList: [],
      bdywList: [],
      sylist: [],
      xqmc: "",
      currhouse: {},
      issyx: false,
      isYouke: false,
      showweixiu: false,
      moduleList: [
        {
          icon: require("../assets/newIcons/小区概况.png"),
          name: "小区概况",
          to: "/wyfw/xqgk_menu",
        },
        {
          icon: require("../assets/newIcons/业主缴费.png"),
          name: "业主缴费",
          to: "/wyfw/jflist",
        },
        {
          icon: require("../assets/newIcons/收支明细.png"),
          name: "收支明细",
          to: "/szmx",
        },
        {
          icon: require("../assets/icon/gs.png"),
          name: "收支公示",
          to: "/wyqy/szgs/index",
        },
        {
          icon: require("../assets/newicon/zhrf.jpg"),
          name: "智慧人防",
          to: "zhrf",
        },
        {
          icon: require("../assets/newIcons/预算公示.png"),
          name: "预算公示",
          to: "/ysgs",
        },
        {
          icon: require("../assets/newIcons/业主决策.png"),
          name: "业主决策",
          to: "/yzjc",
        },
        {
          icon: require("../assets/newIcons/政策法规.png"),
          name: "政策法规",
          to: "/common/list/xxgg",
        },
        {
          icon: require("../assets/icon/bmfw.png"),
          name: "便民服务",
          to: "/bmfw",
        },
      ],
    };
  },
  filters: {
    handleText2(value) {
      if (!value) return "";
      if (value.length > 20) {
        return value.slice(0, 20) + "...";
      }
      return value;
    },
  },
  computed: {
    ...mapState(["userInfo", "identity", "houseId", "isactive"]),
    chooseindex() {
      return this.userInfo.houses?.findIndex((obj) => obj.isDefault) || 0;
    },
    columns() {
      var columns = [];
      if (!this.userInfo.houses) return columns;
      this.userInfo.houses.map((item) => {
        var addarr = item.address.split(" ");
        item.addstr = "";
        addarr.forEach((option, index) => {
          var na = "";
          if (index == 0 && !isNaN(Number(option, 10))) {
            na = option + "栋";
          } else if (index == 1 && !isNaN(Number(option, 10))) {
            na = option + "单元";
          } else if (index == 2 && !isNaN(Number(option, 10))) {
            na = option + "楼";
          } else if (index == 3 && !isNaN(Number(option, 10))) {
            na = option + "室";
          } else {
            na = option;
          }
          item.addstr += na;
        });
        columns.push({
          text: item.communityName + item.addstr,
          value: item.houseId,
        });
      });
      this.gethomeitems1();
      return columns;
    },
    currentHouseName() {
      if (this.currhouse && this.currhouse.communityName) {
        return this.currhouse.communityName + (this.currhouse.addstr || '');
      }
      return '';
    }
  },
  mounted() {
    if (sessionStorage.getItem("to")) {
      if (sessionStorage.getItem('to') == 'gs' && sessionStorage.getItem('gsId')) {
        this.$router.push({
          path: "/yzjc/gsdet",
          query: { id: sessionStorage.getItem('gsId') },
        });
        sessionStorage.setItem("gsId", "");
      } else if (sessionStorage.getItem('to') == 'jctp' && sessionStorage.getItem('jctpId')) {
        sessionStorage.setItem('currentHouseUserType', 1)
        this.$router.push({
          path: "/yzjc/jcdet",
          query: { id: sessionStorage.getItem('jctpId') },
        });
        sessionStorage.setItem("jctpId", "");
      } else {
        this.$router.push({ name: sessionStorage.getItem('to') });
      }
      sessionStorage.setItem("to", "");
      return;
    }
    sessionStorage.removeItem("userInfo");
    sessionStorage.setItem("nowType", "yezhu");
    this.getsqkb();
    this.getxxgg();
    this.getbdyw();
    this.gethomeitems1();

    this.$axios
      .get("/api/v2/wechat/user/userInfo", { params: {} })
      .then((res) => {
        this.changeUserinfo(res);
        this.openId = res.openId;
        if (res.houses.length > 0) {
          sessionStorage.removeItem("isYouke");
          this.currhouse = res.houses.filter((item) => item.isDefault)[0];
          this.issyx = true;
          this.showweixiu = false;
          res.houses.forEach((item) => {
            var addarr = item.address.split(" ");
            item.addstr = "";
            addarr.forEach((option, index) => {
              var na = "";
              if (index == 0 && !isNaN(Number(option, 10))) na = option + "栋";
              else if (index == 1 && !isNaN(Number(option, 10))) na = option + "单元";
              else if (index == 2 && !isNaN(Number(option, 10))) na = option + "楼";
              else if (index == 3 && !isNaN(Number(option, 10))) na = option + "室";
              else na = option;
              item.addstr += na;
            });
          });
          this.changeUserinfo(res);
        } else {
          sessionStorage.setItem("isYouke", true);
          this.xqmc = "测试小区";
          this.isYouke = true;
          this.gethomeitems1();
        }
      });
  },
  methods: {
    ...mapMutations(["changeIdentity", "changeUserinfo", "changeHouseId", "emitactive"]),

    closePage() {
      // 关闭页面逻辑
      if (window.WeixinJSBridge) {
        WeixinJSBridge.call('closeWindow');
      }
    },

    getIconClass(index) {
      const classes = ['red', 'blue', 'purple', 'orange', 'yellow', 'green', 'teal'];
      return classes[index % classes.length];
    },

    gethomeitems1() {
      this.sylist = [];
      // 测试小区（游客模式）显示便民服务菜单
      let menuItems = [
        "小区概况",
        "业主决策",
        "业主缴费",
        "收支明细",
        "收支公示",
        "政策法规",
        // "预算公示",
        "智慧人防",
      ];
      if (this.isYouke || this.currhouse?.communityName === "测试小区") {
        menuItems.push("便民服务");
      }
      localStorage.setItem("shouyeitems", JSON.stringify(menuItems));
      var syname = JSON.parse(localStorage.getItem("shouyeitems"));
      syname.forEach((item) => {
        this.moduleList.forEach((a) => {
          if (a.name == item) this.sylist.push(a);
        });
      });
    },

    getsqkb() {
      this.$axios
        .get("/api/v1/wygl/notice/list", {
          params: {
            houseId: this.houseId || "1504057892783919106",
            pageNum: 0,
            pageSize: 6,
          },
        })
        .then((res) => {
          this.sqkbList = [...res.data].slice(0, 6);
          this.sqkbList.forEach((item) => {
            item.publishDate = item.publishDate?.substring(0, 10);
          });
        });
    },
    getxxgg() {
      this.$axios
        .get(
          "/screen/v1/home/informationList?title=&startTime=&endTime=&pageNum=0&pageSize=6",
          {
            params: {},
          }
        )
        .then((res) => {
          this.xxggList = res.data;
        });
    },
    getbdyw() {
      this.$axios
        .get(
          "/screen/v1/home/localNewsList?title=&startTime=&endTime=&pageNum=0&pageSize=6",
          {
            params: {},
          }
        )
        .then((res) => {
          this.bdywList = res.data;
        });
    },
    gokb() {
      if (this.isYouke) {
        this.$router.push({ path: "/smrz" });
        return;
      }
      if (this.active == 0) {
        this.$router.push({ path: "/common/list/sqkb" });
      } else if (this.active == 1) {
        this.$router.push({ path: "/common/list/bdyw" });
      } else if (this.active == 2) {
        this.$router.push({ path: "/common/list/xxgg" });
      }
    },

    onConfirm(value, index) {
      this.showPicker = false;
      if (index != this.chooseindex) {
        this.$axios
          .get("/api/v2/wechat/user/changeDefaultHouse", {
            params: { houseId: value.value },
          })
          .then((res) => {
            this.currhouse = res.houses.filter((item) => item.isDefault)[0];
            this.changeUserinfo(res);
            this.reload();
          });
      }
    },

    changeview(path, id) {
      sessionStorage.setItem(
        "houseName",
        this.currentHouseName
      );
      if (this.identity != 2 && path == "/yzjc") {
        Dialog.alert({
          message: "您还不是房主，请先去认证房主！",
        }).then(() => {});
        return;
      }
      if (sessionStorage.getItem("isYouke")) {
        if (path !== "/bmfw") {
          this.$router.push({ path: "/smrz" });
          return;
        }
      }
      // if (path == "/bmfw") {
      //   location.href = "https://h5.icsaas.cn/h5/#/?appId=s16780342";
      //   return;
      // }
      if (path == "zhrf") {
        const houseId = this.currhouse?.houseId || '';
        location.href = `https://zhwy.zjj.suqian.gov.cn/manage?openId=${this.openId}&houseId=${houseId}/#/mobile`;
        return;
      }
      if (path == "/wxzj" && this.issyx) {
        this.$router.push({ path: path, query: { type: "syx" } });
      } else {
        this.$router.push({
          path,
          query: { id },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  max-width: 600px;
  margin: 0 auto;
  background-color: #fff;
  min-height: 100vh;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-bottom: 76px;
}

/* 顶部标题栏 */
.header {
  background-color: #fff;
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-center {
  flex: 1;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.header-url {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.header-close,
.header-more {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #333;
  padding: 8px;
}

.header-close {
  left: 16px;
}

.header-more {
  right: 16px;
}

/* 地址信息栏 */
.address-bar {
  background-color: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
}

.address-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.address-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.address-text {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}

.switch-house {
  color: #1890ff;
  font-size: 14px;
}

/* 宣传横幅 */
.banner {
  width: 100%;
  height: 180px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="%23ffffff" fill-opacity="0.1" d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,224C672,245,768,267,864,250.7C960,235,1056,181,1152,165.3C1248,149,1344,171,1392,181.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>') no-repeat bottom;
  background-size: cover;
}

.banner-content {
  text-align: center;
  color: #fff;
  z-index: 2;
}

.banner-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.banner-subtitle {
  font-size: 16px;
  opacity: 0.9;
}

.banner-dept {
  font-size: 12px;
  margin-top: 12px;
  opacity: 0.8;
}

/* 通知公告 */
.notice-bar {
  background-color: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e8e8e8;
}

.notice-icon {
  color: #ff9500;
  font-size: 16px;
  flex-shrink: 0;
}

.notice-text {
  flex: 1;
  overflow: hidden;
}

/* 功能网格 */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 24px 16px;
  background-color: #fff;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.feature-item:active {
  transform: scale(0.95);
}

.feature-icon {
  width: 60px;
  height: 60px;
//  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
//  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.feature-icon.red {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
}

.feature-icon.blue {
  background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
}

.feature-icon.purple {
  background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);
}

.feature-icon.orange {
  background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
}

.feature-icon.yellow {
  background: linear-gradient(135deg, #fdcb6e 0%, #f39c12 100%);
}

.feature-icon.green {
  background: linear-gradient(135deg, #55efc4 0%, #00b894 100%);
}

.feature-icon.teal {
  background: linear-gradient(135deg, #81ecec 0%, #00cec9 100%);
}

.feature-text {
  font-size: 13px;
  color: #333;
  text-align: center;
}

/* 小区快报 */
.xx {
  width: 100%;
  padding: 10px;
  .xxtitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #00b5ff;
    .gd {
      img {
        height: 10px;
      }
      span {
        font-size: 12px;
        margin-right: 5px;
      }
    }
    .titlename {
      height: 20px;
      display: flex;
      align-items: center;
      .line {
        height: 23px;
        width: 4px;
        border-radius: 2px;
        background-color: #00b5ff;
      }
      span {
        margin-left: 10px;
      }
    }

    ::v-deep .van-tab {
      font-size: 16px;
      color: #939ea9;
    }
    ::v-deep .van-tab--active {
      color: #000;
      font-weight: bold;
    }
  }
  .tzcontent {
    height: calc(100% - 25px);
    display: flex;
    align-items: center;
    flex-direction: column;
    .xxitem {
      height: 57px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      position: relative;
      border-bottom: 1px solid lightgray;
      .isbold {
        font-weight: bold;
      }
      .new {
        height: 20px;
        width: 20px;
        background-color: #f26a6a;
        text-align: center;
        font-style: normal;
        color: #fff;
        line-height: 20px;
        font-size: 12px;
        border-radius: 3px;
      }
      .reddot {
        color: red;
        position: absolute;
        top: 2px;
        font-size: 30px;
      }
      .tztitle {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #333333;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 15px;
      }
      .tzdate {
        font-size: 13px;
        color: #999999;
      }
    }
  }
}
.yy {
  width: 100%;
  height: 6px;
  background-color: rgb(244, 244, 244);
}
</style>
